import { IUser } from '@collections/users/interfaces/user.interface';
import {gql, TypedDocumentNode} from 'apollo-angular';

export const UserFragment: TypedDocumentNode<Partial<IUser>>  = gql`
  fragment userFields on User
  {
      _id
      username
      slug
      folder
      roles
      status
      validated
  }
  `;
